// extracted by mini-css-extract-plugin
export default {"root":"BrandingIconCard_root__O0NDs"};